import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { Module } from 'vuex';
import { StoreType } from '@/types/store/store.type';
import { VenueStoreType } from '@/types/store/venue-store.type';

const namespaced: boolean = true;
export const venues: Module<VenueStoreType, StoreType> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
